import { Box, Skeleton } from '@mui/material';

const FormArticulo = () => {
  return (
    <Box>
      <Skeleton
        animation="wave"
        height={10}
        width="40%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton sx={{ height: 40, marginBottom: 1 }} animation="wave" variant="rectangular" />
      <Box display='flex' flexDirection='row' gap={2} justifyContent='space-between'>
        <Skeleton sx={{ height: 40, marginBottom: 1, width: '60%' }} animation="wave" variant="rectangular" />
        <Skeleton sx={{ height: 40, marginBottom: 1, width: '40%' }} animation="wave" variant="rectangular" />
      </Box>
      <Skeleton sx={{ height: 40, marginBottom: 1 }} animation="wave" variant="rectangular" />
      <Box display='flex' flexDirection='row' gap={2} justifyContent='space-between'>
        <Skeleton sx={{ height: 40, marginBottom: 1, width: '40%' }} animation="wave" variant="rectangular" />
        <Skeleton sx={{ height: 40, marginBottom: 1, width: '20%' }} animation="wave" variant="rectangular" />
      </Box>
      <Skeleton
        animation="wave"
        height={30}
        width="40%"
        style={{ marginBottom: 6 }}
      />
    </Box>
  )
}

export default FormArticulo;